.section {
  margin-bottom: 16px;
}

.heading {
  font-size: 1.25rem;
  margin-bottom: 4px;
}
